import React from "react"
import { MdError } from "react-icons/md"
import { Container, Row, Col } from "react-bootstrap"
import "./ErrorMP.css"

const ErrorMP = (props) => {
  return (
    <div className="error-container">
      <Row className="error-header text-danger">
        <Col xs={0} md={3}></Col>
        <Col xs={12} md={6} className="h2 text-center">
          <MdError />
          Oops! Ha ocurrido un error!
        </Col>
        <Col xs={0} md={3}></Col>
      </Row>
      <Row>
        <Col xs={0} md={3}></Col>
        <Col xs={12} md={6} className="error-body text-center">
          {props.children}
        </Col>
        <Col xs={0} md={3}></Col>
      </Row>
    </div>
  )
}

export default ErrorMP
